import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import _get from 'lodash/get';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Mixpanel from 'utils/mixpanelService';
import WrappedSectionArrowRight from './icons/WrappedSectionArrowRight';
import BrainIcon from './icons/Brain.png';

const useStyles = makeStyles({
  root: {
    paddingTop: 25,
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    color: props => props.theme.headerColor,
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '1.5',
  },
  cardWrapper: {
    marginTop: 15,
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    padding: 12,
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
  },
  icon: {
    width: 42,
    height: 42,
    marginRight: 10,
    objectFit: 'contain',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 2,
  },
  title: {
    fontFamily: 'Mada',
    fontWeight: 700,
    fontSize: 14,
    textAlign: 'left',
    lineHeight: '1.5',
    color: '#01619B',
    margin: 0,
  },
  subtitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  subtitle: {
    fontFamily: 'Mada',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '1.5',
    color: '#4B4B4B',
    margin: 0,
  },
  arrowIcon: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
});

const WrappedSection = ({ theme, onHide }) => {
  const classes = useStyles({ theme });
  const history = useHistory();
  const [wrappedPageCopy] = useSiteCopySelector(['wrapped-2025']);
  const pageCopy = _get(wrappedPageCopy, 'pageCopy', {});

  const handleClick = () => {
    Mixpanel.track('Profile - Wrapped Clicked', {
      section: 'sidebar wrapped',
    });
    history.push('/account/recommendations');
    localStorage.setItem('wrapped2025_clicked', 'true');
    onHide();
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.headerWrapper}>
        <Typography className={classes.header}>
          {_get(pageCopy, 'menuItem')}
        </Typography>
      </Box>
      <Box className={classes.cardWrapper}>
        <ButtonBase
          onClick={handleClick}
          className={classes.card}
          aria-label="Your 2025 Wellbeing Wrapped - Celebrate Your Journey in Wellbeing"
          disableRipple
        >
          <img src={BrainIcon} alt="" className={classes.icon} />
          <Box className={classes.contentWrapper}>
            <Typography className={classes.title}>
              {_get(pageCopy, 'sectionTitle')}
            </Typography>
            <Box className={classes.subtitleWrapper}>
              <Typography className={classes.subtitle}>
                {_get(pageCopy, 'sectionSubtitle')}
              </Typography>
              <Box className={classes.arrowIcon}>
                <WrappedSectionArrowRight />
              </Box>
            </Box>
          </Box>
        </ButtonBase>
      </Box>
    </Box>
  );
};

WrappedSection.propTypes = {
  theme: PropTypes.object,
  onHide: PropTypes.func,
};

export default WrappedSection;
